﻿import { IMilestoneSearchResult, IProjectTemplate } from "@/interfaces";
import { fetchBaseQueryWrapper } from "@/services/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";

export const projectTemplateApi = createApi({
  reducerPath: "projectTemplateApi",
  baseQuery: fetchBaseQueryWrapper({
    path: "projectTemplates",
  }),
  endpoints: (build) => ({
    getProjectTemplate: build.query({
      query: (id) => id,
      transformResponse: ({ data }) => data,
      keepUnusedDataFor: 0,
    }),
    getProjectTemplatesByProjectTypeId: build.query({
      query: (id) => `projectType/${id}`,
      transformResponse: ({ data }) => data,
    }),
    getProjectTemplates: build.query<IProjectTemplate[], void>({
      query: () => "",
      transformResponse: ({ data }) => data,
    }),
    saveProjectTemplate: build.mutation({
      query: ({ id, projectTemplate }) => ({
        url: id,
        method: "PATCH",
        body: { ProjectTemplate: projectTemplate },
      }),
    }),

    copyProjectTemplate: build.mutation({
      query: ({ copyFrom, copyTo, milestones }) => ({
        url: `${copyFrom}/${copyTo}/copy`,
        method: "POST",
        body: { milestones },
      }),
    }),

    getAllFlattenedMilestoneTemplates: build.query<
      IMilestoneSearchResult[],
      void
    >({
      query: () => ({
        url: `flattenedMilestones`,
      }),
      transformResponse: ({ data }) => data,
    }),
  }),
});

export const {
  useGetProjectTemplateQuery,
  useLazyGetProjectTemplatesByProjectTypeIdQuery,
  useGetProjectTemplatesQuery,
  useSaveProjectTemplateMutation,
  useCopyProjectTemplateMutation,
  useGetAllFlattenedMilestoneTemplatesQuery,
} = projectTemplateApi;
